import Headline from './headline'

export const AmuiHeadline = Headline

export default Vue => Vue.component(Headline.name, Headline)
